export default __webpack_public_path__ + "static/media/430.1b4254b4.jpg";